import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/blogs.css'; 

const blogsData = [
  {
    id: 1,
    title: 'How to Register and Verify Your Account on the Mahadev App',
    date: '2025-04-09',
    author: 'Vikash Roy',
    views: 5731,
    likes: 623,
    comments: 0,
    excerpt: 'Learn how to easily register and verify your account on the Mahadev app. Follow...',
    imageUrl: '/blog1.webp',
    slug: 'how-to-register-and-verify-your-account-on-the-Mahadev-app',
  },
  {
    id: 2,
    title: 'Mahadev App: Features, Benefits, and Installation Guide',
    date: '2025-04-09',
    author: 'Vikash Roy',
    views: 5391,
    likes: 593,
    comments: 0,
    excerpt: 'Explore the features, benefits, and a complete installation guide for the Mahadev...',
    imageUrl: '/blog2.webp', 
    slug: 'mahadev-app-features-benefits-and-installation-guide',
  },
];

const Blogs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="blogs-container">
      <div className='blogs-title'>
      <h1><span className='highlight'>Mahadev</span> Latest Blogs</h1>
      </div>
      
      <div className='blog-cards'>
      {blogsData.map((blog) => (
        <div key={blog.id} className="blog-card">
          <img src={blog.imageUrl} alt={blog.title} className="blog-image" />
          <div className="blog-content">
            <h3 className="blog-title">{blog.title}</h3>
            <p className="blog-meta">
              By <span className="blog-author">{blog.author}</span> | {blog.date}
            </p>
            <div className="blog-stats">
              <span>👁 {blog.views}</span>
              <span>👍 {blog.likes}</span>
              <span>💬 {blog.comments} Comments</span>
            </div>
            <p className="blog-excerpt">{blog.excerpt}</p>
            <Link to={`/blogs/${blog.slug}`} className="read-more-button">
              Read More
            </Link>
          </div>
        </div>
      ))}
      </div>
    </div>
  );
};

export default Blogs;
